export const localStorageAvailable = () => {
    // checks if the localStorage is available
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
};

export const restoreState = (store, userModule, venueModule, brandModule) => {
    console.log('calling localStorageSession plugin');
    const userToken = localStorage.getItem('userToken');
    const authToken = localStorage.getItem('authToken');
    const selectedVenue = localStorage.getItem('selectedVenue');
    const isDarkMode = localStorage.getItem('isDarkMode');
    const earlyAccess = localStorage.getItem('earlyAccess');
    const brand = localStorage.getItem('brand');
    const userModulePath = userModule ? userModule + '/' : '';
    const venueModulePath = venueModule ? venueModule + '/' : '';
    const brandModulePath = brandModule ? brandModule + '/' : '';
    if (userToken) {
        store.dispatch(`${userModulePath}saveUserToken`, userToken).then(() => {
            return store.dispatch(`${userModulePath}getUserInfo`);
        });
    }
    if (authToken) {
        store.commit(`${userModulePath}setAuthToken`, authToken);
    }
    if (selectedVenue) {
        store.dispatch(
            `${venueModulePath}saveSelectedVenue`,
            JSON.parse(selectedVenue)
        );
    }
    if (isDarkMode) {
        store.commit('setIsDarkMode', JSON.parse(isDarkMode));
    }
    if (earlyAccess) {
        store.commit('setEarlyAccess', JSON.parse(earlyAccess));
    }
    if (brand) {
        store.commit(`${brandModulePath}setMso`, JSON.parse(brand)['mso']);
    }
};

const localStorageSession = store => {
    // will restore session state from local storage
    if (!localStorageAvailable()) {
        return false;
    }
    // load state auth vars from localStorage
    restoreState(store, 'authUser', 'venue', 'brand');
};

export default localStorageSession;
